module.exports = __webpack_public_path__ + "img/02.1d3bc5d1.jpg";